export const mounthData=[
  {id: '01', value: '一月份'},
  {id: '02', value: '二月份'},
  {id: '03', value: '三月份'},
  {id: '04', value: '四月份'},
  {id: '05', value: '五月份'},
  {id: '06', value: '六月份'},
  {id: '07', value: '七月份'},
  {id: '08', value: '八月份'},
  {id: '09', value: '九月份'},
  {id: '10', value: '十月份'},
  {id: '11', value: '十一月份'},
  {id: '12', value: '十二月份'},
];

export const testData = {
  'status': 1,
  'msg': '',
  'error_code': '0',
  'data': {
    'companyInfo': {
      'id': 4,
      'qichacha_name': '成都黑果科技有限公司',
    },
    'service_list': [{
      'id': 1,
      'name': '面对面学术推广',
      'summary': '面对面学术推广',
      'plan_num': 3,
      'done_num': 1,
      'todo_num': 2,
    }, {
      'id': 3,
      'name': '学术资料宣传',
      'summary': '学术资料宣传',
      'plan_num': 2,
      'done_num': 0,
      'todo_num': 2,
    }, {
      'id': 13,
      'name': '主办学术会议',
      'summary': '主办学术会议',
      'plan_num': 2,
      'done_num': 1,
      'todo_num': 1,
    }, {
      'id': 4,
      'name': '样品发放',
      'summary': '样品发放',
      'plan_num': 2,
      'done_num': 0,
      'todo_num': 2,
    }, {
      'id': 5,
      'name': '问卷调研',
      'summary': '问卷调研',
      'plan_num': 15,
      'done_num': 1,
      'todo_num': 14,
    }, {
      'id': 6,
      'name': '零售药店开发',
      'summary': '零售药店开发',
      'plan_num': 1,
      'done_num': 1,
      'todo_num': 0,
    }, {
      'id': 7,
      'name': '新医院开发',
      'summary': '新医院开发',
      'plan_num': 1,
      'done_num': 0,
      'todo_num': 1,
    }],
    'team_list': [{
      'id': 2,
      'team_name': 'fdfd团队',
      'service_provider_list': [{
        'id': 1,
        'name': '1-有限公司',
        'promoter_list': [{
          'id': 46,
          'name': '唐超2',
          'drug_promoter_id': 37,
          'plan_num': 3,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 47,
          'name': '唐超1',
          'drug_promoter_id': 37,
          'plan_num': 8,
          'done_num': 0,
          'todo_num': 2,
        }],
      }, {
        'id': 2,
        'name': '2-有限公司',
        'promoter_list': [{
          'id': 46,
          'name': '唐超3',
          'drug_promoter_id': 37,
          'plan_num': 14,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 47,
          'name': '唐超4',
          'drug_promoter_id': 37,
          'plan_num': 20,
          'done_num': 0,
          'todo_num': 2,
        }],
      }],
    }, {
      'id': 1,
      'team_name': '黑果团队',
      'service_provider_list': [{
        'id': 1,
        'name': '百度在线网络技术（北京）有限公司',
        'promoter_list': [{
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 46,
          'name': '唐超',
          'drug_promoter_id': 37,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 49,
          'name': '李红',
          'drug_promoter_id': 39,
          'plan_num': 2,
          'done_num': 0,
          'todo_num': 2,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 62,
          'name': 'jim7',
          'drug_promoter_id': 54,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 79,
          'name': '线上百度服务商',
          'drug_promoter_id': 66,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 80,
          'name': '测试数据2',
          'drug_promoter_id': 67,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 92,
          'name': '德玛西亚',
          'drug_promoter_id': 130,
          'plan_num': 0,
          'done_num': 0,
          'todo_num': 0,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 97,
          'name': '远远推广',
          'drug_promoter_id': 135,
          'plan_num': 14,
          'done_num': 2,
          'todo_num': 12,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }, {
          'id': 98,
          'name': '百度推广员',
          'drug_promoter_id': 137,
          'plan_num': 6,
          'done_num': 2,
          'todo_num': 4,
        }],
      }],
    }],
  },
};
